import { MantineThemeOverride, rem } from '@mantine/core';
import { P1Regular, P2Regular } from 'theme/typography';
import { TABLET_BREAKPOINT } from 'theme/components/utils/tablet';

export type NavLinkTheme = NonNullable<MantineThemeOverride['components']>['NavLink'];

export const NavLink: NavLinkTheme = {
  styles: (theme) => ({
    root: {
      padding: rem(12),
      borderRadius: rem(4),
      color: theme.colors.gray[9],
      ...P1Regular,
      '&:hover': {
        color: theme.colors.red[6],
        backgroundColor: theme.white,
      },
      '&[data-active="true"]': {
        color: theme.colors.red[6],
        backgroundColor: theme.white,
      },
      '&[data-active="true"]:hover': {
        color: theme.colors.red[6],
        backgroundColor: theme.white,
      },
      '.collapsed &': {
        alignSelf: 'center !important',
      },
      [theme.fn.smallerThan(TABLET_BREAKPOINT)]: {
        padding: rem(8),
        ...P2Regular,
      },
    },

    rightSection: {
      '.collapsed &': {
        display: 'none',
      },
    },

    icon: {
      marginRight: rem(24),
      '.collapsed &': {
        marginRight: rem(0),
      },
      [theme.fn.smallerThan(TABLET_BREAKPOINT)]: {
        marginRight: rem(16),
      },
    },
    label: {
      ...P1Regular,
      '.parentCollapsed &': {
        display: 'none',
      },
    },
    children: {
      paddingLeft: 0,
      '& .collapsed': {
        paddingLeft: rem(8),
        gap: rem(16),
      },

      '& button': {
        paddingTop: rem(8),
        paddingBottom: rem(8),
        paddingLeft: rem(30),
        '& span': {
          ...P2Regular,
        },
        [theme.fn.smallerThan(TABLET_BREAKPOINT)]: {
          paddingTop: rem(6),
          paddingBottom: rem(6),
          paddingLeft: rem(24),
        },
      },
    },
  }),
};
